/**
 * Page infrastructure mapper
 * normalizes data to be used in pages
 *
 * @param {Object} data - cms data
 * @return {Object} - normalized page data
 */
export default (data: any) => {
  if (!data) {
    return null
  }
  return {
    contentLocale: data.locale || '',
    introText: data.introText || null,
    chapters: data.chaptersCollection?.items || []
  }
}
